export enum OrganizationTypeFormFields {
  OrganizationType = 'organizationType',
}
